<div
  *ngIf="!!coupon"
  class="coupon-card"
  [class.inactive]="isRedeemed || coupon.status !== CouponCodeItemStatus.Issued"
  [class.active]="isActive"
>
  <div *ngIf="coupon.status !== CouponCodeItemStatus.Issued" class="invalid-coupon">
    <span>{{ coupon.status }}</span>
  </div>
  <img class="coupon-image" [src]="coupon.pictureUrl" alt="Coupon image" />
  <div class="subtitle text-truncate mt-2">{{ coupon.name }}</div>
  <div class="title fw-bold text-truncate">{{ coupon.title }}</div>
</div>
